import Barcode from './Barcode';

export default Barcode;
